import React, { lazy } from 'react';
import { motion } from 'framer-motion';
type Testimonial = {
  name: string;
  role: string;
  avatar: string;
  quote: string;
  highlight: string;
};
const testimonials: Testimonial[] = [{
  name: 'Jean Martin',
  role: '🇫🇷 Entraîneur U12 · Lyon, France',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces',
  quote: "Avant, je passais deux heures chaque soir à monter l'entraînement. Avec le Pack Complet, j'arrive au club avec la séance prête et les jeunes progressent mieux.",
  highlight: "J'ai récupéré mes soirées en une semaine."
}, {
  name: 'Marc Dubois',
  role: "🇧🇪 Professeur d'EPS · Bruxelles, Belgique",
  avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&h=200&fit=crop&crop=faces',
  quote: "Les séances par catégorie sont de l'or pur. Tout mon cycle scolaire est planifié et les parents ont remarqué la différence sur les matchs.",
  highlight: 'Tout le cycle planifié.'
}, {
  name: 'Thomas Leroy',
  role: '🇫🇷 Entraîneur U15 · Nantes, France',
  avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=faces',
  quote: "Le Manuel de Gardiens m'a débloqué quelque chose que je repoussais depuis des années. Mes gardiens ont énormément progressé en 2 mois.",
  highlight: 'Mes gardiens ont totalement changé.'
}, {
  name: 'Camille Bernard',
  role: '🇨🇭 Entraîneuse U10 · Lausanne, Suisse',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop&crop=faces',
  quote: "Ce que j'apprécie le plus, c'est le tableau HD. J'imprime, je marque et les filles comprennent l'action instantanément. Ça vaut 10 fois ce que j'ai payé.",
  highlight: "Ça vaut 10 fois ce que j'ai payé."
}, {
  name: 'Olivier Lambert',
  role: '🇫🇷 Directeur Sportif · Marseille, France',
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop&crop=faces',
  quote: "Je l'ai acheté pour mon staff. Maintenant tous les entraîneurs du club parlent le même langage et les planifications sont cohérentes.",
  highlight: 'Tout le staff du club unifié.'
}, {
  name: 'Sophie Renaud',
  role: '🇨🇦 Entraîneuse U12 · Montréal, Canada',
  avatar: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=200&h=200&fit=crop&crop=faces',
  quote: "Je pensais que ce serait un PDF de plus. Je me trompais. C'est un système complet, structuré et applicable dès le premier jour.",
  highlight: 'Applicable dès le premier jour.'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-28 px-4 sm:px-6 relative overflow-hidden" data-id="element-251">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-primary/10 rounded-full blur-[120px] pointer-events-none" data-id="element-252"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-253">
        <div className="text-center mb-10 sm:mb-16" data-id="element-254">
          <span className="inline-block text-secondary font-bold text-xs sm:text-sm tracking-widest uppercase mb-3" data-id="element-255">
            ⭐ Ce que disent les entraîneurs
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight mb-4" data-id="element-256">
            +500 entraîneurs ont déjà{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-blue-400" data-id="element-257">
              récupéré leur temps
            </span>
          </h2>
          <div className="flex items-center justify-center gap-2 mt-4" data-id="element-258">
            <span className="text-secondary text-lg sm:text-xl drop-shadow-[0_0_8px_rgba(245,158,11,0.5)]" data-id="element-259">
              ⭐⭐⭐⭐⭐
            </span>
            <span className="text-text-sec text-sm sm:text-base font-medium" data-id="element-260">
              4.9/5 · Avis vérifiés
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-261">
          {testimonials.map((t, i) => <motion.article key={t.name} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: i * 0.08,
          duration: 0.5
        }} className="bg-bg-alt border border-border-light rounded-2xl p-5 sm:p-7 flex flex-col h-full hover:border-primary/40 transition-colors shadow-[0_0_30px_rgba(0,0,0,0.2)]" data-id="element-262">
              <div className="text-secondary text-sm mb-3 drop-shadow-[0_0_6px_rgba(245,158,11,0.4)]" data-id="element-263">
                ⭐⭐⭐⭐⭐
              </div>

              <p className="text-text-main font-bold text-base sm:text-lg leading-snug mb-3" data-id="element-264">
                "{t.highlight}"
              </p>

              <p className="text-text-sec text-sm sm:text-base leading-relaxed mb-6 flex-1" data-id="element-265">
                {t.quote}
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-266">
                <img src={t.avatar} alt={t.name} loading="lazy" decoding="async" width={44} height={44} className="w-11 h-11 rounded-full object-cover border-2 border-primary/30" data-id="element-267" />
                <div className="min-w-0" data-id="element-268">
                  <div className="flex items-center gap-1.5" data-id="element-269">
                    <span className="text-text-main font-bold text-sm truncate" data-id="element-270">
                      {t.name}
                    </span>
                    <span className="text-primary text-xs flex-shrink-0" title="Achat vérifié" data-id="element-271">
                      ✓
                    </span>
                  </div>
                  <p className="text-text-sec text-xs truncate" data-id="element-272">{t.role}</p>
                </div>
              </div>
            </motion.article>)}
        </div>

        <div className="text-center mt-10 sm:mt-14" data-id="element-273">
          <a href="#pricing" className="inline-block bg-cta-green hover:bg-cta-green-hover text-white font-black text-base sm:text-xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl transition-all shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/10" data-id="element-274">
            🚀 JE VEUX LES REJOINDRE
          </a>
          <p className="text-text-sec text-xs sm:text-sm mt-3 font-medium" data-id="element-275">
            Accès immédiat · Garantie 7 jours
          </p>
        </div>
      </div>
    </section>;
}